export default __webpack_public_path__ + "static/media/Shaka_particle_final_07.47076eb9.png";